import {Component, EventEmitter, inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DxFormComponent} from "devextreme-angular";
import {Gateway} from "../../../../../models/gateway/Gateway";
import {BaseComponent} from "../../../../BaseComponent";
import {GatewayTypeOpeService} from "../../../../../services/ope/gatewayTypeOpe.service";
import {GatewayType} from "../../../../../models/gateway-type/GatewayType";
import {SendingCronFrequencyEnum} from "../../../../../enums/registry/SendingCronFrequencyEnum";

@Component({
  selector: 'app-gateway-create-form',
  templateUrl: './gateway-create-form.component.html',
  styleUrls: ['./gateway-create-form.component.css', '../../gateway-device.component.css', '../../../../common/drawer-style.css', '../../../base-component-with-drawer.component.css']
})
export class GatewayCreateFormComponent extends BaseComponent implements OnInit {

  @Output() addGatewayChange = new EventEmitter<boolean>();

  get addGateway(): boolean {
    return this._addGateway;
  }

  @Input() set addGateway(value: boolean) {
    this._addGateway = value;
    this.addGatewayChange.emit(value);
  }

  @ViewChild('newGatewayForm', {static: false}) newGatewayForm!: DxFormComponent;
  @Output() putGateway: EventEmitter<Gateway> = new EventEmitter<Gateway>();
  @Output() resetSelectedRowPartitionNewGatewayForm: EventEmitter<void> = new EventEmitter<void>();
  @Input() newGateway?: Gateway;
  @Input() isNewFormValid?: boolean;
  @Input() gatewayTypes: GatewayType[] = [];

  protected readonly gatewayTypeOpeService: GatewayTypeOpeService = inject(GatewayTypeOpeService);

  private _addGateway: boolean;

  protected sendingCronFrequencyValues: string[];

  /**
   * Text box options for gateway fields
   */
  gatewayNewTextOptions = {
    valueChangeEvent: 'keyup'
  };

  constructor() {
    super();
    this._addGateway = false;
    this.sendingCronFrequencyValues = Object.values(SendingCronFrequencyEnum);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }


  /**
   * Call putGateway ope with new gateway
   */
  createNewGateway() {
    this.checkNewGatewayValidation();

    if (this.isNewFormValid)
      this.putGateway.emit(this.newGateway);
  }

  /**
   * Check if new gateway is valid
   */
  checkNewGatewayValidation() {
    const result = this.newGatewayForm.instance.validate();
    this.isNewFormValid = !!result.isValid;
  }

  getAcquisitionCronLabel = (acquisitionCron: string) => {
    return this.translate.instant('FREQUENCY.' + acquisitionCron);
  };
}
